import { FC, useContext } from 'react';
import { IconCircleCheckMarkHollow } from '../../icons/Icons';
import GlobalContext from '../../contexts/GlobalContext';
import { Stack, Typography, useTheme } from '@mui/material';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';

const MultiFactorAuthDisabledSuccess: FC = () => {
    const { language } = useContext(GlobalContext);
    const theme = useTheme();

    return (
        <PageLayoutV2>
            <Stack alignItems={'center'} textAlign={'center'}>
                <IconCircleCheckMarkHollow width="46px" height="47px" fillColor={theme.palette.grey[600]} />
                <Typography
                    sx={{
                        fontSize: '24px',
                        fontWeight: 400,
                        marginTop: '12px',
                        color: theme.palette.grey[600],
                    }}
                    component={'h1'}
                >
                    {language.multiFactorAuthDisabled.header}
                </Typography>
                <Typography
                    sx={{
                        fontSize: '16px',
                        fontWeight: 400,
                        marginTop: '16px',
                        color: theme.palette.grey[600],
                    }}
                    component={'p'}
                >
                    {language.multiFactorAuthDisabled.message}
                </Typography>
            </Stack>
        </PageLayoutV2>
    );
};

export default MultiFactorAuthDisabledSuccess;
